'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import { AlertRootContext } from './context/alert-root.context';
import { alertCloseStyles } from './styles/alert-close.styles';
import type { AlertClosePropsInterface } from './types/alert-close.types';

/**
 * @since 10.0.0
 */
export const AlertClose = forwardRef<HTMLDivElement, AlertClosePropsInterface>(
  (props: AlertClosePropsInterface, forwardedRef) => {
    const { handleClose } = useContext(AlertRootContext);
    const { className, children, css: cssProp, ...rest } = props;

    const styles = css(alertCloseStyles, cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-component="Alert.Close"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        {...rest}
      >
        <Slot onClick={handleClose}>{children}</Slot>
      </div>
    );
  },
);

AlertClose.displayName = 'Alert.Close';
